<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div class="flex items-center">
      <div class="dropdown-heading-icon flex items-center justify-center">
        @if (user()?.photoURL; as photoURL) {
          <div class="h-10 w-10 rounded-full overflow-hidden">
            <img [src]="photoURL" [alt]="'shared.toolbarUserDropdown.userAvatarAlt' | translate" class="h-full w-full object-cover">
          </div>
        } @else {
          <mat-icon svgIcon="mat:person"></mat-icon>
        }
      </div>
      <div class="dropdown-heading">{{ userName() }}</div>
    </div>
  </div>

  <div class="dropdown-content">
    @for (item of items(); track trackById($index, item)) {
      <!-- Admin item - special handling to show contextual sidebar -->
      @if (item.id === 'admin') {
        <a
          (click)="goToAdmin()" (keydown.enter)="goToAdmin()"
          tabindex="0"
          class="notification flex items-center"
          matRipple>
          <mat-icon
            [ngClass]="item.colorClass"
            [svgIcon]="item.icon"
          class="notification-icon flex-none"></mat-icon>
          <div class="flex-auto">
            <div class="notification-label">{{ item.label | translate }}</div>
            <div class="notification-description">{{ item.description | translate }}</div>
          </div>
          <mat-icon
            class="notification-chevron flex-none"
          svgIcon="mat:chevron_right"></mat-icon>
        </a>
      }
      <!-- Regular items -->
      @if (item.id !== 'admin') {
        <a
          (click)="close()" (keydown.enter)="close()"
          [routerLink]="item.route"
          [queryParams]="item.queryParams"
          class="notification flex items-center"
          matRipple>
          <mat-icon
            [ngClass]="item.colorClass"
            [svgIcon]="item.icon"
          class="notification-icon flex-none"></mat-icon>
          <div class="flex-auto">
            <div class="notification-label">{{ item.label | translate }}</div>
            <div class="notification-description">{{ item.description | translate }}</div>
          </div>
          <mat-icon
            class="notification-chevron flex-none"
          svgIcon="mat:chevron_right"></mat-icon>
        </a>
      }
    }
  </div>

  <!-- Online-status selector removed: presence was never persisted nor read
       anywhere, so it was a control that looked functional but did nothing. -->
  <div class="dropdown-footer flex items-center justify-end">
    <button (click)="logout()" (keydown.enter)="logout()" color="primary" mat-button>
      {{ 'shared.navigation.signOut' | translate }}
    </button>
  </div>
</div>
